import { ROUTES } from "library/routes";
import { Navigate, RouteProps, useLocation } from "react-router-dom";

import useEmployee from "hooks/useEmployee";

type Props = {
  children: JSX.Element;
} & RouteProps;

export const ConsentGuardedRoute = ({ children }: Props) => {
  const location = useLocation();
  const { employeeData } = useEmployee();

  const isProfilePage = location.pathname === ROUTES.PROFILE;
  const isHomePage = location.pathname === ROUTES.HOME;

  if (!employeeData) return null;

  return employeeData?.isConsentGiven || isHomePage ? (
    <>{children}</>
  ) : (
    <Navigate to={isProfilePage ? ROUTES.PROFILE : ROUTES.HOME} />
  );
};
